import React from 'react';

import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';

import withCheckPermission from '../../../shared/check-permission-hoc';
import CheckboxField from '../../../shared/form-elements/checkbox';
import http from '../../../shared/http';

import { enum as permissions } from '../../../../../../../enums/admin-permissions';

function SettingField({ check, id, title, value, applySettingToAllAdmins }) {
	return (
		<div className='admin-setting' id={id}>
			<Field
				name={`settings.${id}`}
				placeholder={title}
				component={CheckboxField}
				normalize={(v) => !!v}
			/>
			{check(permissions.adminsSetGlobalPermissions) && (
				<button type='button' onClick={() => applySettingToAllAdmins(value)}>
					Apply setting to all admins
				</button>
			)}
		</div>
	);
}

const selector = formValueSelector('adminSettings');

function mapStateToProps(state, props) {
	return {
		value: selector(state, `settings.${props.id}`)
	};
}

function mapDispatchToProps(dispatch, props) {
	return {
		applySettingToAllAdmins: (value) => {
			const request = http({
				url: `/v2/admins/settings/hidden-item`,
				method: 'put',
				data: {
					action: value ? 'remove' : 'append',
					settingId: props.id
				},
				actions: ['']
			});

			return request(dispatch);
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withCheckPermission(SettingField));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/settings/field.js